<div class="row">
    <div class="col-48 outer-b-medium">
        <button class="btn btn-border-radius btn-secondary" type="button" (click)="createGroup()">
            <span translate>Create new group</span>
        </button>
    </div>
</div>
<div class="row">
    <div class="col-md-48 col-lg-48 col-48">
        <table-container
                [noResultMessage]="'No groups were found for this domain' | translate"
                [collection]="groups"
                (onPageChange)="onPageChange($event)"
                (onPerPageChange)="onPageSizeChange($event)"
                [progress]="promise">
            <table class="table table-hover table-fixed">
                <thead>
                    <tr>
                        <th class="col-md-36" translate>
                            Title
                        </th>
                        <th class="col-md-12 text-right">
                            <button class="btn btn-border-radius btn-secondary"
                                    type="button"
                                    [disabled]="domain.running_groups"
                                    monModalConfirm="{{'Updating groups can take more than 30 minutes. During the operation you will not be able to create and update groups.' | translate }}"
                                    (monModalConfirmAction)="updateDomainGroupsRules()">
                                <span translate>Update groups</span>
                                <span class="fas fa-spinner fa-spin fa-lg" *ngIf="domain.running_groups"></span>
                            </button>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let group of groups">
                        <td class="text-ellipsis">{{group.title}}</td>
                        <td class="text-right text-v-middle" [attr.aria-label]="'Actions' | translate">
                            <!-- Show spinner per group while it's updating; hide action menu to prevent edits -->
                            <span *ngIf="group.updating">
                                <span translate>Updating</span>
                                <span class="fas fa-spinner fa-spin outer-l-small"></span>
                            </span>
                            <mon-action-menu *ngIf="!group.updating" [monActionMenuItems]="group.dropdown" class="outer-l-small">
                                <span translate>Action</span>
                            </mon-action-menu>
                        </td>
                    </tr>
                </tbody>
            </table>
        </table-container>
    </div>
</div>
